// ============================================================
// BG VIDEO WRAPPER (Lazy init przez IntersectionObserver)
// ============================================================

export function initBgVideos() {
    const videoWrappers = document.querySelectorAll('.bg-video-wrapper');
    if (videoWrappers.length === 0) return;

    const initVideo = (wrapper) => {
        const type   = wrapper.dataset.videoType;
        const target = wrapper.querySelector('.video-target');
        let html     = '';

        if (type === 'mp4') {
            const src = wrapper.dataset.videoSrc;
            if (src) {
                html = `<video autoplay loop muted playsinline><source src="${src}" type="video/mp4"></video>`;
            }
        } else if (type === 'youtube') {
            const id = wrapper.dataset.videoId?.trim();
            if (id) {
                html = `<iframe
                    src="https://www.youtube.com/embed/${id}?autoplay=1&mute=1&controls=0&loop=1&playlist=${id}&playsinline=1&showinfo=0&rel=0&iv_load_policy=3&disablekb=1&enablejsapi=1"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    style="pointer-events: none;">
                </iframe>`;
            }
        }

        if (!html) return;

        target.innerHTML = html;

        if (type === 'mp4') {
            const videoEl = target.querySelector('video');
            videoEl.addEventListener('play', () => wrapper.classList.add('video-playing'));
        } else {
            setTimeout(() => wrapper.classList.add('video-playing'), 1500);
        }
    };

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initVideo(entry.target);
                obs.unobserve(entry.target);
            }
        });
    }, { rootMargin: '100px' });

    videoWrappers.forEach(wrapper => observer.observe(wrapper));
}
